/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Link from '../../base/Link';
import SectionContainer from '../SectionContainer';
import Typography from '../../base/Typography';
import { Col, Row } from '../../base/Grid';

export const ColLeftStyled = styled(Col)`
  display: flex;
  flex: 0 0 auto;
  padding: 0;
`;

export const ColRightStyled = styled(Col)`
  display: flex;
  flex: 0 1 auto;
  flex-wrap: wrap;
  padding: 0;
`;

export const LinkStyled = styled(Link)`
  ${({ theme, sectionVariant }) => {
    const primarySection = sectionVariant === 'primary';
    return css`
      margin-right: ${rem(15)};
      margin-left: ${theme.mediumUp() ? rem(15) : 0};
      ${primarySection && `color: ${theme.colors.neutral.white}`};
      :hover {
        ${primarySection && `color: ${theme.colors.neutral.gray87}`};
      }
  `;
  }
}`;

export const LIStyled = styled.li`
  ${({ theme }) => css`
    display: ${theme.mediumUp() ? 'inline' : 'block'};
  `
}`;

export const RowStyled = styled(Row)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      display: flex;
      flex-wrap: unset;
      flex-direction: ${mediumUp ? 'row' : 'column'};
    `;
  }
}`;

export const SectionContainerStyled = styled(SectionContainer)`
  ${({ theme }) => css`
    padding-top: ${theme.mediumUp() ? rem(48) : rem(32)};
  `
}`;

export const TypographyListItemStyled = styled(Typography)`
  ${({ theme, lastItem }) => {
    const mediumUp = theme.mediumUp();
    return css`
      padding-bottom: 0;
      ${mediumUp && 'white-space: nowrap;'}
      display: inline-block;
      :after {
        ${(!lastItem && mediumUp) && 'content: \' | \';'};
      }
    `;
  }
}`;

export const TypographyStyled = styled(Typography)`
  text-transform: uppercase;
`;

export const ULStyled = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;
